import dayjs from 'dayjs';

import {
  MemberTicketStatusEnum,
  MemberTicketType,
  SpeakerRequestStatusEnum,
  SpeakerRequestType,
} from 'graphql/types';

// устанавливает условия, определяющие возможность повторной подачи заявок
export const isAllowedToApply = (
  application: MemberTicketType | SpeakerRequestType | null,
  isAuthorized: boolean
) => {
  if (!isAuthorized || !application) {
    return true;
  }

  return (
    (application?.status === MemberTicketStatusEnum.Declined ||
      application?.status === SpeakerRequestStatusEnum.Declined) &&
    dayjs().subtract(7, 'day').format('YYYY-MM-DD') >= application?.denialDate
  );
};
